import axios from 'axios';

export function createCrusaderRecord(applicationId) {
    return axios.post('/api/services/app/ApplicationStudentProfiles/CreateCrusaderRecord', { id: applicationId });
}